<template>
    <form>
        <div class="alert alert-danger" v-if="error">{{ error }}</div>
        <div class="alert alert-success" v-if="success">{{ success }}</div>
        <template v-if="token">
            <div class="mt-3">
                <v-form-field
                    label="Email"
                    required
                    type="email"
                    v-model="email"
                />
            </div>
            <div class="mt-3">
                <v-form-field
                    label="New Password"
                    required
                    type="password"
                    v-model="password"
                />
            </div>
            <div class="mt-3">
                <v-form-field
                    label="Confirm Password"
                    required
                    type="password"
                    v-model="password_confirm"
                />
            </div>
            <v-flex align="center" class="mt-3" justify="end">
                <v-button @click.prevent="reset" block variant="primary"
                    >Reset</v-button
                >
            </v-flex>
        </template>
        <template v-else>
            <div class="mt-3">
                <v-form-field
                    label="Email"
                    required
                    type="email"
                    v-model="email"
                />
            </div>
            <v-flex align="center" class="mt-3" justify="end">
                <v-button @click.prevent="send" block variant="primary"
                    >Reset</v-button
                >
            </v-flex>
        </template>
    </form>
</template>

<script>
import Vue from "vue";
import { ladderVue } from "@@/services/ladder";
import VFormField from "@/components/ui/VFormField";

Vue.use(ladderVue);

export default {
    name: "VAuthReset",
    components: { VFormField },
    props: {
        token: {
            required: false,
            type: String
        },
        suggestedEmail: {
            required: false,
            type: String
        }
    },
    data() {
        return {
            success: null,
            error: null,
            email: "",
            password: null,
            password_confirm: null
        };
    },
    created() {
        if (this.suggestedEmail) {
            this.email = this.suggestedEmail;
        }
    },
    methods: {
        async send() {
            this.error = null;
            this.success = null;
            if (this.email) {
                try {
                    let response = await this.$ladder.create(
                        "users/password/reset",
                        { email: this.email }
                    );
                    Object.assign(this.$data, this.$options.data.apply(this));
                    this.success = response.message;
                } catch (e) {
                    this.error = e.message;
                }
            } else {
                this.error = "Please type in your email address";
            }
        },
        async reset() {
            this.error = null;
            this.success = null;
            if (this.email && this.password && this.password_confirm) {
                try {
                    let response = await this.$ladder.replace(
                        "users/password",
                        {
                            email: this.email,
                            token: this.token,
                            password: this.password,
                            password_confirm: this.password_confirm
                        }
                    );
                    Object.assign(this.$data, this.$options.data.apply(this));
                    this.success = response.message;
                    this.$emit("reset");
                } catch (e) {
                    this.error = e.message;
                }
            } else {
                this.error = "Please fill in all fields";
            }
        }
    }
};
</script>
